import { Page } from '@app/components/page/Page';
import { AuditIcon } from '@app/modules/audit/components/AuditIcon';
import { useIntl } from 'react-intl';
import { Route, Switch } from 'react-router-dom';
import { aodRoutes } from '../../routing/routes';
import { AodRulesListPage_v2 } from '../aod-rules-list-v2/AodRulesListPage_v2';
import { AodRunsListPage_v2 } from '../aod-runs-list-v2/AodRunsListPage_v2';
import { AodRunsScheduledPage_v2 } from '../aod-runs-scheduled-v2/AodRunsScheduledPage_v2';

export function AodPage() {
  const { $t } = useIntl();

  return (
    <Page>
      <Page.Header
        icon={<AuditIcon />}
        title={[
          $t({
            id: 'audit.title',
            defaultMessage: 'Auditoría',
          }),
          $t({
            id: 'audit.aod.titleLong',
            defaultMessage: 'Automatic Order Delivery',
          }),
        ]}
        tabs={[
          {
            to: aodRoutes.runsPast.path,
            text: $t({
              id: 'audit.aod.tabs.runsPast',
              defaultMessage: 'Ejecuciones Pasadas',
            }),
            isActive: (match: any, location: any) =>
              location.pathname.startsWith(aodRoutes.runsPast.path),
          },
          {
            to: aodRoutes.runsScheduled.path,
            text: $t({
              id: 'audit.aod.tabs.runsScheduled',
              defaultMessage: 'Ejecuciones Programadas',
            }),
            isActive: (match: any, location: any) =>
              location.pathname.startsWith(aodRoutes.runsScheduled.path),
          },
          {
            to: aodRoutes.rules.gen(),
            text: $t({
              id: 'audit.aod.tabs.rules',
              defaultMessage: 'Reglas',
            }),
            isActive: (match: any, location: any) =>
              location.pathname === aodRoutes.rules.path ||
              location.pathname === aodRoutes.root.path,
          },
        ]}
      />
      <Switch>
        <Route path={aodRoutes.runsPast.path}>
          <AodRunsListPage_v2 />
        </Route>
        <Route path={aodRoutes.runsScheduled.path}>
          <AodRunsScheduledPage_v2 />
        </Route>
        <Route path={aodRoutes.rules.path}>
          <AodRulesListPage_v2 />
        </Route>
      </Switch>
    </Page>
  );
}
